<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-3" icon="fa fa-industry" titulo="DETALHES DA ORDEM DE ABATE">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap w-100">
            <div class="d-flex align-items-center mr-4">
              <span class="mr-2">
                <i class="fa fa-barcode mr-1 text-info"></i>
                LOTE: <strong class="text-white">{{registro.LOTE || '...'}}</strong>
              </span>
              <span class="mx-2 opacity-50">•</span>
              <span class="mr-2">
                <i class="fa fa-calendar mr-1 text-info"></i>
                EMISSÃO: {{registro.DT_LANCAMENTO}}
              </span>
            </div>
            
            <div class="d-flex align-items-center">
              <b-badge pill class="px-3 py-1 shadow-sm mr-2 border border-white-50" 
                :variant="registro.STATUS === '6' ? 'success' : (['3', '4', '5'].includes(registro.STATUS) ? 'info' : 'warning')">
                {{traduzStatus}}
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button v-if="exibirBotaoReabrir" variant="link" class="btn-glass btn-glass-warning px-4 font-weight-bold shadow-sm" @click.stop.prevent="onReabrir()">
            <i class="fa fa-unlock mr-1"></i> REABRIR PLANEJAMENTO
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="onVoltarPrincipal()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <b-row class="px-2">
        <b-col sm="12">
          
          <!-- Card: Identificação Básica -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center">
              <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                <i class="fa fa-id-card"></i>
              </div>
              <div>
                <h6 class="mb-0 font-weight-bold text-dark">Identificação e Dados Gerais</h6>
                <small class="text-muted">Informações básicas da ordem de abate</small>
              </div>
            </div>
            
            <div class="p-4">
              <b-row>
                <b-col sm="2">
                  <label class="modal-label-premium">Código ID</label>
                  <b-form-input type="text" :disabled="true" class="rounded-pill bg-gray-100 border-0 font-weight-bold text-center" v-model="registro.ID"></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Número Lote</label>
                  <b-form-input type="text" :disabled="true" class="rounded-pill bg-gray-100 border-0 font-weight-bold text-center" v-model="registro.LOTE"></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Data Emissão</label>
                  <b-form-input type="date" :disabled="true" class="rounded-pill bg-gray-100 border-0 text-center" v-model="registro.DT_LANCAMENTO"></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Hora Início</label>
                  <b-form-input type="time" :disabled="true" class="rounded-pill bg-gray-100 border-0 text-center" v-model="registro.HORA_SAI"></b-form-input>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Situação</label>
                  <b-form-input type="text" :disabled="true" class="rounded-pill bg-gray-100 border-0 font-weight-bold" v-model="traduzStatus"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col sm="2">
                  <label class="modal-label-premium">Data do Lote</label>
                  <b-form-input type="date" :disabled="true" class="rounded-pill bg-gray-100 border-0 text-center" v-model="registro.DT_LOTE"></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Hora Entrada</label>
                  <b-form-input type="time" :disabled="true" class="rounded-pill bg-gray-100 border-0 text-center" v-model="registro.HORA_ENT"></b-form-input>
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">GTA</label>
                  <b-form-input type="text" :disabled="true" class="rounded-pill bg-gray-100 border-0 text-center" v-model="registro.GTA"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Tipo de Ordem</label>
                  <b-form-select :disabled="true" class="rounded-pill bg-gray-100 border-0" v-model="registro.VINCULA_COMPRA_GADO" :options="tipoOrdem"></b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Tipo de Processo</label>
                  <b-form-select :disabled="true" class="rounded-pill bg-gray-100 border-0" v-model="registro.OP_TIPO_SERVICO" :options="tipoServico"></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <b-row>
            <b-col sm="7">
              <!-- Card: Interessados -->
              <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
                <div class="bg-light p-3 border-bottom d-flex align-items-center">
                  <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                    <i class="fa fa-users"></i>
                  </div>
                  <h6 class="mb-0 font-weight-bold text-dark">Interessados e Logística</h6>
                </div>
                
                <div class="p-4">
                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <cliente-pesquisa 
                        @retornaId="registro.CLIENTE_ID = $event"
                        :idInicial="registro.CLIENTE_ID"
                        :desabilitarInput="true"
                        id="edCLIENTE_ID"
                        idModal="modalCliente"
                        label="Cliente"
                        place="Informe o Fornecedor"
                        labelBotao="">
                      </cliente-pesquisa>
                    </b-col>
                    <b-col sm="12" class="mb-3">
                      <cliente-pesquisa 
                        @retornaId="registro.MARCHANT_ID = $event"
                        :idInicial="registro.MARCHANT_ID"
                        :desabilitarInput="true"
                        idModal="modalMarchant"
                        label="Marchante"
                        id="edMARCHANT_ID"
                        place="Informe o Marchant"
                        labelBotao="">
                      </cliente-pesquisa>
                    </b-col>
                    <b-col sm="12" class="mb-3">
                      <cliente-pesquisa 
                        @retornaId="registro.FAZENDA_ID = $event"
                        :idInicial="registro.FAZENDA_ID"
                        :desabilitarInput="true"
                        idModal="modalFazenda"
                        label="Fazenda"
                        id="edFAZENDA_ID"
                        place="Informe a Fazenda"
                        labelBotao="">
                      </cliente-pesquisa>
                    </b-col>
                    <b-col sm="12" class="mb-3">
                      <funcionario-pesquisa 
                        @retornaId="registro.BALANCEIRO_ID = $event"
                        :idInicial="registro.BALANCEIRO_ID"
                        :desabilitarInput="true"
                        idModal="modalBalanceiro"
                        label="Responsável"
                        id="edBALANCEIRO_ID"
                        place="Informe o Responsável"
                        labelBotao="">
                      </funcionario-pesquisa>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <centro-estoque-pesquisa 
                        @retornaId="registro.CENTRO_ESTOQUE_ORIGEM_ID = $event"
                        :idInicial="registro.CENTRO_ESTOQUE_ORIGEM_ID"
                        :desabilitarInput="true"
                        idModal="modalCentroEstoqueOrigem"
                        label="Estoque de Origem"
                        id="edCENTRO_ESTOQUE_ORIGEM_ID"
                        place="Informe Estoque de Origem"
                        labelBotao="">
                      </centro-estoque-pesquisa>
                    </b-col>
                    <b-col sm="6">
                      <centro-estoque-pesquisa 
                        @retornaId="registro.CENTRO_ESTOQUE_ID = $event"
                        :idInicial="registro.CENTRO_ESTOQUE_ID"
                        :desabilitarInput="true"
                        idModal="modalCentroEstoqueDestino"
                        label="Estoque de Destino"
                        id="edCENTRO_ESTOQUE_ID"
                        place="Informe Estoque de Destino"
                        labelBotao="">
                      </centro-estoque-pesquisa>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="8">
                      <custo-operacional-pesquisa 
                        @retornaId="registro.CUSTO_OPERACIONAL_ID = $event"
                        :idInicial="registro.CUSTO_OPERACIONAL_ID"
                        :desabilitarInput="true"
                        id="edCUSTO_OPERACIONAL_ID"
                        idModal="modalCustoOperacional"
                        label="Custo Operacional"
                        place="Informe o Custo Operacional"
                        labelBotao="">
                      </custo-operacional-pesquisa>
                    </b-col>
                    <b-col sm="4">
                      <label class="modal-label-premium">Custo Oper. KG/R$</label>
                      <vue-autonumeric v-model="registro.VL_CUSTO_OPERACIONAL" 
                        :options="'Brazilian'" 
                        :disabled="true"
                        class="form-control rounded-pill bg-gray-100 border-0 text-right font-weight-bold">
                      </vue-autonumeric>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>

            <b-col sm="5">
              <!-- Card: Animais -->
              <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
                <div class="bg-light p-3 border-bottom d-flex align-items-center">
                  <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                    <i class="fa fa-paw"></i>
                  </div>
                  <h6 class="mb-0 font-weight-bold text-dark">Animais do Lote</h6>
                </div>
                <div class="p-0">
                  <b-table striped hover responsive :items="tabelaAnimais.items" :fields="tabelaAnimais.fields" class="mb-0 border-0">
                  </b-table>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <!-- Card: Resumo Abate -->
              <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
                <div class="bg-light p-3 border-bottom d-flex align-items-center">
                  <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                    <i class="fa fa-list-alt"></i>
                  </div>
                  <h6 class="mb-0 font-weight-bold text-dark">Resumo do Abate</h6>
                </div>
                <div class="p-0">
                  <b-table striped hover responsive :items="tabelaAbatidos.items" :fields="tabelaAbatidos.fields" class="mb-0 border-0">
                  </b-table>
                </div>
              </b-card>
            </b-col>
            <b-col sm="6">
              <!-- Card: Classificação -->
              <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
                <div class="bg-light p-3 border-bottom d-flex align-items-center">
                  <div class="bg-danger text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                    <i class="fa fa-tags"></i>
                  </div>
                  <h6 class="mb-0 font-weight-bold text-dark">Resumo por Classificação</h6>
                </div>
                <div class="p-0">
                  <b-table striped hover responsive :items="tabelaResumoClassificacao.items" :fields="tabelaResumoClassificacao.fields" class="mb-0 border-0">
                  </b-table>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <!-- Card: Pesagem -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-0">
            <div class="bg-light p-3 border-bottom d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="bg-dark text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center shadow-sm" style="width: 35px; height: 35px;">
                  <i class="fa fa-balance-scale"></i>
                </div>
                <h6 class="mb-0 font-weight-bold text-dark">Itens Pesados (Tempo Real)</h6>
              </div>

              <div class="d-flex align-items-center bg-white rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                </b-button-group>
              </div>
            </div>
            <div class="p-0">
              <b-table striped hover responsive :items="tabelaPesados.items" :fields="tabelaPesados.fields" class="mb-0 border-0">
              </b-table>
            </div>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import CustoOperacionalPesquisa from '../../pesquisa/CustoOperacionalPesquisa.vue'
import AnimalPesquisa from '../../pesquisa/AnimalPesquisa.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    VueButtonSpinner,
    HeaderPadrao,
    FuncionarioPesquisa,
    ClientePesquisa,
    VueAutonumeric,
    CentroEstoquePesquisa,
    CustoOperacionalPesquisa,
    AnimalPesquisa
  },
  data () {
    return {
      intervalId: null,
      desabilitado: true,
      isLoading: false,
      status: '',
      submmited: false,
      monitoraAlteracao: false,
      registroMonitoramento: [],
      itensForamAlterados: false,
      registro: {
            ID                        : null,
            BALANCEIRO_ID             : null,
            COMPRADOR_ID              : null,
            CLIENTE_ID                : null,
            LOTE                      : null,
            DT_LOTE                   : null,
            DT_LANCAMENTO             : null,
            USUARIO                   : null,
            DT_ALTERACAO              : null,
            USUARIO_ALTERACAO         : null,
            VL_EMBARQUE               : null,
            OBS                       : null,
            HORA_ENT                  : null,
            STATUS                    : null,
            CIDADE                    : null,
            CENTRO_ESTOQUE_ID         : null,
            MARCHANT_ID               : null,
            FAZENDA_ID                : null,
            VACA                      : null,
            NOVILHA                   : null,
            BOI                       : null,
            TOURO                     : null,
            BOI_INTEIRO               : null,
            BOI_CAPAO                 : null,
            BUFALO_MACHO              : null,
            BUFALO_FEMEA              : null,
            CUSTO_OPERACIONAL_ID      : null,
            HORA_SAI                  : null,
            OP_FECHADO_EXPEDICAO      : null,
            GTA                       : null,
            DATA_GTA                  : null,
            MINUTA                    : null,
            CENTRO_ESTOQUE_ORIGEM_ID  : null,
            COMPRA_GADO_ID            : null,
            VL_CUSTO_VACA             : null,
            VL_CUSTO_NOVILHA          : null,
            VL_CUSTO_TOURO            : null,
            VL_CUSTO_BUFALO_MACHO     : null,
            VL_CUSTO_BUFALO_FEMEA     : null,
            VL_CUSTO_BOI_INTEIRO      : null,
            VL_SERVICO_CABECA         : null,
            VL_CUSTO_OPERACIONAL      : 0.00,
            VL_CUSTO_BOI              : null,
            DT_VENCIMENTO_ARECEBER    : null,
            DT_VENCIMENTO_APAGAR      : null,
            OP_CREDOR                 : null,
            OP_DEVEDOR                : null,
            VL_UNT_RESERVA            : null,
            VL_TOTAL_RESERVA          : null,
            VL_TOTAL_SERVICO          : null,
            CENTRO_CUSTO_APAGAR_ID    : null,
            CENTRO_CUSTO_ARECEBER_ID  : null,
            HISTORICO_ARECEBER_ID     : null,
            HISTORICO_APAGAR_ID       : null,
            NR_CABECAS                : null,
            NR_CABECAS_RESERVA        : null,
            QUANT_RESERVA             : null,
            VINCULA_COMPRA_GADO       : null,
            OP_TIPO_SERVICO           : null,
            OP_FECHADO_DIARIO         : null,
            OBS_PLANO_EXPEDICAO       : null,
            DT_PREVISAO_EXPEDICAO     : null,
      },
      tabelaPesados: {
        fields: [
          {
            key: "SEQUENCIAL",
            label: "Sequência",
            class: "text-center my-left-border my-left-right my-left-bottom"
          },
          {
            key: "INDICE",
            label: 'Etiqueta',
            class:'text-right my-left-border my-left-right my-left-bottom',
          },
          {
            key: "SIGLA",
            label: 'Qualidade',
            class:'text-right my-left-border my-left-right my-left-bottom',
          },
          {
            key: "DESCRICAO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'BANDA1', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Banda1 (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'BANDA2', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Banda2 (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'PESO_TOTAL', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Animal (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "CLASSIFICACAO",
            label: 'Classificação',
            class:'my-left-border my-left-right my-left-bottom',
          }
        ],
        items: []
      },
      tabelaAbatidos: {
        fields: [
          {
            key: "DESCRICAO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'BANDAS', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Bandas'
          },
          {
            key: 'QUANT', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'MEDIA', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Media (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
      tabelaResumoClassificacao: {
        fields: [
          {
            key: "NOME_PRODUTO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'DESCRICAO', 
            class:'font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Classificacao'
          },
          {
            key: 'PESO', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
              value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
      tipoOrdem: [
        {value: '0', text: '0 - ORDEM NÃO VINCULADA A COMPRA DE GADO'},
        {value: '1', text: '1 - ORDEM VINCULADA A COMPRA DE GADO'}
      ],
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      tabelaAnimais: {
        fields: [
          {
            key: "NOME_PRODUTO",
            label: 'Animal'
          },
          {
            key: "CENTRO_ESTOQUE_ID",
            label: 'Estoque Origem'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
               value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Cabeças'
          }
        ],
        items: []
      }
      
    }
  },
  methods: {
    onVoltarPrincipal() {
      this.$router.push(`/producao/ordemabate/listagem`)
    },
    async onReabrir () {
      const imprimir = await this.$bvModal.msgBoxConfirm('Reabrir a Ordem de Abate?.', {
        title: 'Reabrir',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (imprimir == false) {
        return
      }
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/abate/reabrir/${this.registro.ID}`)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)    
        this.toastCount++
        this.$root.$bvToast.toast(`Ordem de Abate Alterada com Sucesso`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        this.$router.replace(`/producao/ordemabate/edit/${this.registro.ID}`)
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    atualizarListaAnimal () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getAnimalListagemByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.updateItems(this.tabelaAnimais.items, result.data, 'ID')
          //this.tabelaAnimais.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaColeta () {
      //this.tabelaPesados.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/abate/item/getViewPesagemByAbateId/${this.registro.ID}?ordem=W`)
        .then(result =>{
          this.updateItems(this.tabelaPesados.items, result.data, 'ID')
          //this.tabelaPesados.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaPesados () {
      //this.tabelaAbatidos.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getViewDetalheByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.updateItems(this.tabelaAbatidos.items, result.data, 'ID')
          //this.tabelaAbatidos.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaClassificacao () {
      //this.tabelaResumoClassificacao.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getRelViewResumosByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.updateItems(this.tabelaResumoClassificacao.items, result.data, 'ID')
          //this.tabelaResumoClassificacao.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      this.desabilitado = false
      let reg = await this.getRegistroById(id)
      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
      
      reg.data.DT_LOTE = moment(new Date(reg.data.DT_LOTE)).format('YYYY-MM-DD')
      reg.data.DT_LANCAMENTO = moment(new Date(reg.data.DT_LANCAMENTO)).format('YYYY-MM-DD')
      reg.data.DT_ALTERACAO = moment(new Date(reg.data.DT_ALTERACAO)).format('YYYY-MM-DD')
      reg.data.HORA_ENT = moment(new Date(reg.data.HORA_ENT)).format('HH:mm:ss')
      reg.data.HORA_SAI = moment(new Date(reg.data.HORA_SAI)).format('HH:mm:ss')
      
      this.registro = reg.data
      
      this.tabelaAnimais.items = []

      if (await this.atualizarListaAnimal() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
   
      if (await this.atualizarListaColeta() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }

      if (await this.atualizarListaPesados() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      } 

      if (await this.atualizarListaClassificacao() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      } else {
        this.$store.commit('controle/setAguardando', false)
      }
      
      return
      
    },
    updateItems(oldTableItems, newItems, idKey) {
      // Clona os itens antigos
      const oldItems = oldTableItems.slice();

      // Cria um mapa para fácil busca
      const oldItemsMap = oldItems.reduce((map, item) => {
        map[item[idKey]] = item;
        return map;
      }, {});

      // Adiciona ou atualiza
      newItems.forEach(newItem => {
        if (oldItemsMap[newItem[idKey]]) {
          // Atualiza se já existe
          Object.assign(oldItemsMap[newItem[idKey]], newItem);
        } else {
          // Adiciona se não existe
          oldItems.push(newItem);
        }
      });

      // Remove itens que não estão mais na nova lista
      oldTableItems.splice(0, oldTableItems.length, ...oldItems.filter(item => newItems.some(newItem => newItem[idKey] === item[idKey])));

      // Força a reatividade se necessário
      this.uniqueKey += 1; // Incrementa o key para forçar a re-renderização da tabela
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.tabelaPesados.items,
        columns: this.tabelaPesados.fields.filter(f => f.key !== 'actions'),
        reportTitle: 'Resumo pesagem Abate: ' + this.registro.ID + ' - Lote ' + this.registro.LOTE,
        printedBy: window.localStorage.getItem('login') ?? '—',
        filename: 'itens_pesados.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.tabelaPesados.items,
        columns: this.tabelaPesados.fields.filter(f => f.key !== 'actions'),
        filename: 'itens_pesados.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.tabelaPesados.items,
        columns: this.tabelaPesados.fields.filter(f => f.key !== 'actions'),
        filename: 'itens_pesados.csv',
      });
    }
  },
  created () {
    // nao monitorar o botao gravar

    

  },
  mounted() {
    let id = this.$route.params.id
    this.iniciarAlteracao(id)

    // Configura o intervalo para consultar a cada 8 segundos
    this.intervalId = setInterval(() => {
        this.iniciarAlteracao(id);
    }, 8000);
  },
  beforeDestroy() {
    // Limpa o intervalo quando o componente é destruído
    clearInterval(this.intervalId)
  },
  computed: {
    traduzStatus : function () {
      if (this.registro.STATUS == null) return ''
      switch (this.registro.STATUS) {
        case  '0' : return 'CANCELADA'
        case  '1' : return 'LANCAMENTO PRINCIPAIS' 
        case  '2' : return 'PLANEJAMENTO CONCLUIDO' 
        case  '3' : return 'PRONTO PARA COLETA' 
        case  '4' : return 'COLETA INICIADA' 
        case  '5' : return 'COLETA ENCERRADA'     
        case  '6' : return 'FECHADO' 
        case  '7' : return 'PAUSA' 
        default:
          break;
      }
    },
    exibirBotaoReabrir: function () {
      return ['3','7'].includes(this.registro.STATUS)
    }
  }
}
</script>


<style scoped>
/* Estilos específicos se necessário */
</style>


// WEBPACK FOOTER //
// src/views/producao/ordemabate/OrdemAbateDetalhes.vue